// Generated by ts-to-zod
import { z } from 'zod'

export const iActionSchema = z.object({
  type: z.string(),
  payload: z.union([z.record(z.unknown()), z.unknown(), z.never()]).optional()
})
